<template>
    <ul class="search-suggestions" ref="results">
        <li
            tabindex="0"
            v-for="(suggestion, key) in suggestions"
            :key="key"
            :class="['search-suggestions__item', { '-is-active': isActive(key) }]"
            :aria-selected="isActive(key) ? 'true' : 'false'"
            :ref="`suggestion-${key}`"
            v-html="suggestion.formatted"
            @keydown.up="prev"
            @keydown.down="next"
            @focus="focus(key)"
        />
    </ul>
</template>

<script>
import $mediator from 'wee-mediator';
import Tabbable from '../../../scripts/tabbable.js';

// TODO: Make this a helper
const formatResult = (query, result, url) => {
    const re = new RegExp('(' + query.split(' ').join('|') + ')', 'gi');

    return `<a href="/${url}">${result.replace(re, '<b>$1</b>')}</a>`;
}

let tabbable;
let tabbableTimeout;

export default {
    props: {
        id: {
            type: Number,
        },
        items: {
            type: Array,
        },
        query: {
            type: String,
        },
    },
    mounted() {
        $mediator.on(`search-${this.id}.suggest-down`, () => {
            if (this.$refs['suggestion-0'] && this.$refs['suggestion-0'].length) {
                this.$refs['suggestion-0'][0].focus();
            }
        });
    },
    methods: {
        focus(key) {
            this.state.activeIndex = key;
        },
        next() {
            if (this.state.activeIndex < this.suggestions.length - 1) {
                this.state.activeIndex += 1;

                this.$refs[`suggestion-${this.state.activeIndex}`][0].focus();
            }
        },
        prev() {
            if (this.state.activeIndex > 0) {
                this.state.activeIndex -= 1;
                this.$refs[`suggestion-${this.state.activeIndex}`][0].focus();
            }
        },
        isActive(key) {
            return key === this.state.activeIndex;
        },
    },
    watch: {
        items() {
            this.suggestions = this.items.map((item) => ({
                raw: item.getRaw('title'),
                formatted: formatResult(this.query, item.getRaw('title'), item.getRaw('url')),
            }));

            clearTimeout(tabbableTimeout);
                tabbable = null;

                // Debounce this, it's kind of heavy
                tabbableTimeout = setTimeout(() => {
                    tabbable = new Tabbable({
                        el: this.$refs.results,
                        callback() {
                            tabbable.$firstEl[0].focus();
                        }
                    });
                }, 500);
        }
    },
    data: () => ({
        suggestions: [],
        state: {
            activeIndex: -1,
        },
    }),
};
</script>
